import React from 'react';
import { Outlet } from 'react-router-dom';

import { Footer } from './Footer';
import { Header } from './Header';
import { ProtectedRoute } from './PrivateRoute';

export function RootLayout() {
  return (
    <>
      <ProtectedRoute>
        <div className='global_container'>
          <Header />
          {/* <div className="side_bar_outlet_contain"> */}
          {/* <SideBar /> */}
          <div className='outlet_contain'>
            <Outlet />
          </div>
          <Footer />
          {/* </div> */}
        </div>
      </ProtectedRoute>
    </>
  );
}
